
export type TrendListResponsePageAllOfThreeContentItemBasicInfoAllOfTwoCategory = typeof TrendListResponsePageAllOfThreeContentItemBasicInfoAllOfTwoCategory[keyof typeof TrendListResponsePageAllOfThreeContentItemBasicInfoAllOfTwoCategory];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const TrendListResponsePageAllOfThreeContentItemBasicInfoAllOfTwoCategory = {
  TOPIC: 'TOPIC',
  TWEET: 'TWEET',
  USER: 'USER',
  PROJECT: 'PROJECT',
} as const;
